
        var result = require("!!../../../node_modules/css-loader/index.js!./dialog-wrapper.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/dialog-wrapper/dialog-wrapper.component.css
// module id = 2462
// module chunks = 1